import(/* webpackMode: "eager", webpackExports: ["LoadingAnimation"] */ "/var/www/vhosts/metalogic.kz/httpdocs/src/components/modules/loading/index.ts");
